import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getVendors = (query, token) => {
    let qs = buildQuery(query);
    let url = `${baseUrl}/vendors${qs}`;
    return axios.get(url, {
        headers: {
            authorization: token
        }
    })
}

export const getVendorList = (token) => axios.get(`${baseUrl}/vendor-list`, {
    headers: {
        authorization: token
    }
})

export const createVendor = (data, token) => axios.post(`${baseUrl}/vendor`, data, {
    headers: {
        authorization: token
    }
})

export const deleteVendor = (id, token) => axios.delete(`${baseUrl}/vendor/${id}`, {
    headers: {
        authorization: token
    }
})

export const updateVendor = (id, data, token) => axios.patch(`${baseUrl}/vendor/${id}`, data, {
    headers: {
        authorization: token
    }
})

export const getVendorById = (id, token) => axios.get(`${baseUrl}/vendor/${id}`, {
    headers: {
        authorization: token
    }
})

// export const getProjectsByUserId = (id, query, token) => {
//     let qs = buildQuery(query);
//     let url = `${baseUrl}/projects/user/${id}${qs}`;
//     return axios.get(url, {
//         headers: {
//             authorization: token
//         }
//     })
// }